export const GET_TOKEN_BEGIN   = 'POST_LOGING_BEGIN';
export const GET_TOKEN_SUCCESS = 'POST_LOGING_SUCCESS';
export const GET_TOKEN_FAILURE = 'POST_LOGING_FAILURE';

export const GET_TOKEN_LOGIN = 'GET_TOKEN_LOGIN';
export const GET_TOKEN_LOGOUT = 'GET_TOKEN_LOGOUT';

export const PREVENT_TOKEN_LOGOUT = 'PREVENT_TOKEN_LOGOUT'




export function getToken(params) {
  //console.log("hit")
  let apiurl = window.apiurl
    return dispatch => {
      dispatch(getTokenBegin());
      return fetch("https://"+apiurl+"/api/Token", {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(params)
      })
        .then(handleErrors)
        .then(res => res.json())
        .then(json => {
          
          let tokendata = json.token;
          dispatch(getTokenSuccess(tokendata));
          dispatch(getTokenLogin());
          
          //dispatch(getTokenSuccess(json));
          return json;
        })
        .catch(error => dispatch(getTokenFailure(error)));
    };
  }
  
 
function handleErrors(response) {
    if (!response.ok) {
      throw Error(response.status);
    }
    return response;
  }


export const getTokenBegin = () => ({
    type: GET_TOKEN_BEGIN
  });
  
export const getTokenSuccess = tokendata => ({
    type: GET_TOKEN_SUCCESS,
    payload: { tokendata }
  });

  export const getTokenLogin = islogin => ({
    type: GET_TOKEN_LOGIN,
    payload: { islogin }
  });

  export const getTokenLogout = islogin => ({
    type: GET_TOKEN_LOGOUT,
    payload: { islogin }
  });
  
  export const getTokenFailure = error => ({
    type: GET_TOKEN_FAILURE,
    payload: { error }
  });

  export const preventLogout = tokendata => ({
    type: PREVENT_TOKEN_LOGOUT,
    payload: { tokendata }
  });


